import React, { useMemo } from 'react'
import { Locale, Translation } from 'locale'
import { SplitButtonDropdown, ActionItem } from 'view/components/menus'
import { HaircutEntryDetail, CrudEventEnum } from 'api'
import { ActionsButtonProps } from 'view/components/datagrid'
import { useCloneHaircutDialog, useDeleteHaircut, useEditHaircutDialog } from '../useHaircutActions'
import { useSelector } from 'react-redux'
import { canManageHaircutsSelector } from 'selectors/permissionSelectors'

export type HaircutActionsButtonProps = ActionsButtonProps<HaircutEntryDetail>

const hasDeletePermission = (haircutEntryDetail: HaircutEntryDetail) => haircutEntryDetail.availableEvents.includes(CrudEventEnum.DELETE)
const hasEditPermission = (haircutEntryDetail: HaircutEntryDetail) => haircutEntryDetail.availableEvents.includes(CrudEventEnum.UPSERT)

export const HaircutEntryActionsButton: React.FC<HaircutActionsButtonProps> = ({ isGroupRow, items }) => {
  const canManageHaircuts = useSelector(canManageHaircutsSelector)
  const deleteItems = useMemo(() => items.filter(hasDeletePermission), [items])
  const editItems = useMemo(() => items.filter(hasEditPermission), [items])

  const onDelete = useDeleteHaircut()
  const editHaircut = useEditHaircutDialog()
  const cloneHaircut = useCloneHaircutDialog()

  const getLabel = (baseLabel: Translation, details: HaircutEntryDetail[]) => {
    const count = isGroupRow ? ` (${details.length})` : ``
    return `${Locale.translate(baseLabel)}${count}`
  }

  const haircutEntryActions: ActionItem[] = [
    {
      label: getLabel(Translation.TC_ACTION_EDIT, editItems),
      onClick: () => editHaircut(editItems[0]?.haircutEntry?.id),
      enabled: canManageHaircuts && editItems.length === 1
    },
    {
      label: getLabel(Translation.TC_ACTION_CLONE, editItems),
      onClick: () => cloneHaircut(editItems[0]?.haircutEntry?.id),
      enabled: canManageHaircuts && editItems.length === 1
    },
    {
      label: getLabel(Translation.TC_ACTION_DELETE, deleteItems),
      onClick: () => onDelete(deleteItems.map(h => h.haircutEntry.id)),
      enabled: canManageHaircuts && deleteItems.length > 0
    }
  ]

  return <SplitButtonDropdown actions={haircutEntryActions} maxButtons={1} />
}
